// Zod-free constants so the SPA bundle stays lean.
export const MODES = ["in-person", "online", "one-to-one", "hybrid"] as const;
export const TECH = ["none", "board", "projector", "devices"] as const;
export const EMPHASES = ["speaking", "writing", "accuracy", "fluency", "exam", "calm", "energy", "mixed-ability"] as const;
export const STAGE_KINDS = ["warmup", "main", "practice", "wrapup", "extension", "other"] as const;
export type Mode = (typeof MODES)[number];
export type Tech = (typeof TECH)[number];
export type Emphasis = (typeof EMPHASES)[number];
export type StageKind = (typeof STAGE_KINDS)[number];

export const MODE_LABELS: Record<Mode, string> = {
  "in-person": "In the classroom",
  online: "Online group",
  "one-to-one": "One-to-one",
  hybrid: "Hybrid",
};
export const TECH_LABELS: Record<Tech, string> = {
  none: "Nothing but paper",
  board: "Whiteboard",
  projector: "Projector",
  devices: "Student devices",
};
export const EMPHASIS_LABELS: Record<Emphasis, string> = {
  speaking: "More speaking",
  writing: "More writing",
  accuracy: "Accuracy",
  fluency: "Fluency",
  exam: "Exam practice",
  calm: "Calmer class",
  energy: "Needs energy",
  "mixed-ability": "Very mixed ability",
};
